import { SalesReport } from "../../types";
import apiClient from "../apiClient";
import { SalesReportFilters } from "./types.api";

export const getSalesReport = async (
  params: SalesReportFilters,
): Promise<SalesReport> => {
  const response = await apiClient.get("reports/sales", { params });
  return response.data;
};
